<template>
  <div>
    <div v-if="$apollo.loading">
      <v-progress-linear indeterminate color="primary" />
    </div>
    <v-card v-else>
      <apexchart type="line" :options="chartOptions" :series="tableValues" class="ma-2" />
    </v-card>
  </div>
</template>

<script>
import es from "@/lang/chart_es";
import { getQuotas } from "@/apollo/queries";

const moment = require("moment-timezone");

export default {
  name: "Silicon",
  data() {
    return {
      tableValues: [],
      chartOptions: {
        chart: {
          animations: {
            enabled: false,
          },
          toolbar: {
            show: false,
          },
          locales: [es],
          defaultLocale: "es",
        },
        xaxis: {
          type: "datetime",
          labels: {
            style: {
              fontSize: "0.9em",
            },
          },
        },
        yaxis: {
          labels: {
            style: {
              fontSize: "0.9em",
            },
            formatter: value => `${this.format_plot(value, 0)}%`,
          },
        },
        annotations: {
          yaxis: [
            {
              y: 0,
              strokeDashArray: 0,
              borderColor: "#775DD0",
            },
          ],
        },
        stroke: {
          curve: "smooth",
          width: 2,
        },
        legend: {
          show: false,
        },
        tooltip: {
          y: {
            formatter: value => `${this.format_plot(value)}%`,
          },
        },
        responsive: [
          {
            breakpoint: 600,
            options: {
              chart: {
                height: 300,
              },
              legend: {
                position: "bottom",
              },
            },
          },
        ],
        colors: ["#00AA9D"],
      },
    };
  },
  methods: {
    format_plot(value, digits = 2) {
      return value.toLocaleString("es-CL", {
        minimumFractionDigits: digits,
        maximumFractionDigits: digits,
      });
    },
    formatName(name) {
      const replaced = name
        .replace(/FONDO DE INVERSIÓN|FONDO DE INVERSION|FONDO INVERSIÓN|FONDO INVERSION|FONDO DE INV./, "FI")
        .replace(/FONDO MUTUO/, "FM");
      return replaced;
    },
  },
  apollo: {
    quotas: {
      query: getQuotas,
      variables() {
        return {
          currency: "CLP",
          funds: [{ fund: 9725, series: "C", category: "INV" }],
          dates: {
            startDate: "2019-04-04",
            endDate: moment
              .tz(moment(), "America/Santiago")
              .subtract(1, "days")
              .format("YYYY-MM-DD"),
          },
        };
      },
      result({ data, loading }) {
        if (!loading) {
          const output = [];
          data.quotas.forEach(item => {
            if (!item.currency) {
              return;
            }
            const exists = output.find(
              out =>
                // eslint-disable-next-line implicit-arrow-linebreak
                out.fundId === item.fundId && out.series === item.series && out.category === item.category,
            );
            if (exists) {
              exists.data.push({
                x: `${item.date} CLT`,
                y: item.adjustedReturn,
              });
            } else {
              output.push({
                fundId: item.fundId,
                series: item.series,
                category: item.category,
                name: `${this.formatName(item.fund.name)} - ${item.series}`,
                data: [
                  {
                    x: `${item.date} CLT`,
                    y: item.adjustedReturn,
                  },
                ],
              });
            }
          });
          this.tableValues = output;
        }
      },
    },
  },
};
</script>

<style scoped></style>
